import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { PermissionSetContainerModel } from 'blg-akaun-ts-lib';
import { ViewColumnState } from '../../../../application-controller/store/states/view-col.states';
import { PermissionWizardModel, PermWizardLine } from '../../../../models/permission-wizard.model';

export interface PermWizardState extends EntityState<PermissionSetContainerModel> {

    newPermWizard: PermissionWizardModel,
    selectedPermWizard: PermissionWizardModel,
    selectedPermTemplate: any,
    selectedPermWizardLine: PermWizardLine,

    updatePermWizardListing: boolean,

    selectedGuid: string;
    errorLog: {timeStamp: Date, log: string}[];
    totalRecords: number,
    requiresUpdate: boolean;
    viewCache: ViewColumnState;
}

export const permWizardAdapters: EntityAdapter<PermissionSetContainerModel> = createEntityAdapter<PermissionSetContainerModel>({
    selectId: a => a.app_perm_set_hdr.guid.toString()
});

export const initialState: PermWizardState = permWizardAdapters.getInitialState({

    newPermWizard: null,
    selectedPermWizard: null,
    selectedPermTemplate: null,
    selectedPermWizardLine: null,

    updatePermWizardListing: false,

    selectedGuid: null,
    errorLog: [],
    totalRecords: 0,
    requiresUpdate: false,
    viewCache: null
})
